@if (gapStore.gapCandidates$ | async; as gapCandidates) {
  <pr-gap-candidate-list [gap]="gap$ | async" [gapCandidates]="gapCandidates" />
  <mat-divider />
  <pr-wait-list
    [gap]="gap$ | async"
    [gapCandidates]="gapCandidates"
    [waitlist]="waitListStore.smartWaitListCandidates$ | async"
  />
}
